import { memo } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import cn from 'classnames';
import { ITag } from 'src/interface';
import { Element, RouterLink, Title } from 'src/components';

interface IProps {
    items: ITag[];
}

export function ContentTagSection(props: IProps) {
    const { items = [] } = props;

    return (
        <>
            <Element className={'mt-[13px] mb-[8px]'}>
                <Title
                    className={cn(
                        'text-[1.5rem] leading-[1] uppercase',
                        'mb-[8px]'
                    )}
                >
                    Tìm nhanh
                </Title>
                <Element className={'mx-[-4px]'}>
                    {items.slice(0, 8).map((item: ITag, index: number) => {
                        const handleClick = () => {
                            ReactGA4.event({
                                category: 'mobile_search',
                                action: 'clickQuickSearch',
                            });
                        };
                        return (
                            <RouterLink
                                to={item.url}
                                className={cn(
                                    'text-[1.6rem] leading-[2] text-[#6c757d]',
                                    'inline-block',
                                    'h-[32px]',
                                    'px-[8px] m-[4px]',
                                    'rounded-[3px]',
                                    'bg-white',
                                    'border border-solid border-[#dee2e6]'
                                )}
                                key={index}
                                onClick={handleClick}
                            >
                                {item.name}
                            </RouterLink>
                        );
                    })}
                </Element>
            </Element>
        </>
    );
}

export default memo(ContentTagSection);
